import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const constantRoutes = [
  {
    path: '/',
    redirect: '/portal'
  },
  {
    path: '/portal',
    name: 'CustomerPortal',
    component: () => import('@/views/management/CustomerPortal.vue'),
    meta: { title: '客户门户' }
  },
  {
    path: '/MyShipments',
    redirect: '/portal'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRoutes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 客户门户'
  }
  next()
})

export default router
